// Auth
export const LOGIN_URL = "Auth/login";
export const Post_Register_URL = "Auth/Register";
export const Post_RefreshToken_URL = "Auth/refresh";
export const GET_USER_PROFILE_URL = "Auth/info";
export const Post_UpdateUSER_PROFILE_URL = "Auth/UpdateUserProfile";
export const Post_UpdateUserPassword_URL = "Auth/ChangePassword";
export const Post_VerifyInternalAppLogin_URL = "Auth/VerifyInternalAppLogin";
// export const Get_CustomerApps_URL = "http://appmanagerapi.nativesystemsltd.com/Auth/GetCustomerApps";
export const Get_CustomerApps_URL = "Auth/GetCustomerApps";
export const GET_AllUsers_URL = "RestaurantUsers/GetAll"
export const Post_Logout_URL = "Auth/Logout";

// User Reservation
export const Post_Reservation_URL = "Reservation/AddReservation";
export const Update_Reservation_URL = "Reservation/UpdateReservation";
export const Get_Reservations_URL = "Reservation/GetAllReservations";
export const Get_Reservation_URL = "Reservation/GetReservation";
export const Get_All_Print_Reservation_URL =
	"Reservation/GetAllPrintReservations";
export const Delete_Reservations_URL = "Reservation/DeleteReservation";
export const Get_GetTotalReservations_URL =
	"Reservation/GetTotalReservations";
export const Get_ResturentCapacityStatus_URL =
	"Reservation/ResturentCapacityStatus";
export const Get_VerifyUpdateReservation_URL =
	"Reservation/VerifyUpdateReservation";
export const Post_ReservationStatus_URL =
	"Reservation/UpdateReservationStatus";
// Language Translation
export const Get_LanguageDictionary_URL = `Language/GetLanguageDictionary`;
export const Post_AddNewText_URL = `Language/AddNewText`;

// File Manager URL's
export const Post_FileUpload_URL = "FileManager/Upload";
export const Get_File_URL = "FileManager/Get";
export const Get_DeleteFile_URL = "FileManager/DeleteFile";
export const Get_FileInfo_URL = "FileManager/GetFileInfo";

// Time Slots
export const Get_All_TimeSlots_URL = "Reservation/GetTimeSlots";
export const Get_GetAvailableTimeSlots_URL =
	"Reservation/GetAvailableTimeSlots";
export const Upsert_TimeSlots_URL = "Reservation/UpsertTimeSlot";
export const Delete_TimeSlots_URL = "Reservation/DeleteTimeSlot";
export const Get_TimeSlotsById_URL = "Reservation/GetTimeSlotById";

// Customers
export const Get_All_Customers_URL = "/Customer/GetAllCustomersWithPagination";
export const Upsert_Customers_URL = "Customer/UpsertCustomer";
export const Delete_Customers_URL = "/Customer/DeleteCustomer";

// Max Capacities
export const Get_MaxCapacity_URL = "Reservation/GetMaxCapacities";
export const Upsert_MaxCapacity_URL = "Reservation/UpsertMaxCapacity";
export const Delete_MaxCapacity_URL = "Reservation/DeleteMaxCapacity";

//Days-off
export const Get_All_DaysOff_URL = "Reservation/GetAllDaysOff";
export const Get_CalendarDaysOff_URL = "Reservation/GetAllCalenderDaysOff";
export const Upsert_DaysOff_URL = "Reservation/UpsertDayOff";
export const Delete_DaysOff_URL = "Reservation/DeleteDayOff";

// Close Services
export const Post_CloseService_URL = "Reservation/CloseService";
export const Get_CloseService_URL = "Reservation/CloseServiceStatus";
export const Get_Summary_URL = "TableManagement/GetTablesSummary";

// SystemSetting
export const Get_ServerDateTime_URL = "/SystemSetting/GetServerDateTime";
export const Get_Email_URL = "System/GetEmail";
export const Post_Email_URL = "System/UpdateEmail";
export const Get_SystemSetting_URL = "System/GetSystemSetting";

export const Post_UpsertSystemSetting_URL = "/System/UpsertSystemSetting";
export const Get_UploadMenuFile_URL = "System/UploadMenuFile";

export const Get_AllMenuFile_URL = "System/GetAllMenuFiles";
export const Post_AddMenuFile_URL = "System/AddMenuFile";

export const Get_Logo_URL = "System/GetLogo";
export const Post_ChangeLogo_URL = "System/ChangeLogo";
export const Post_DeleteLogo_URL = "System/DeleteLogo";


// Block Service

export const Get_All_BlockRules_URL    = "ReservationStop/GetAll";
export const Create_BlockRule_URL      = "ReservationStop/Create";
export const Update_BlockRule_URL      = "ReservationStop/Update";
export const Delete_BlockRule_URL      = "ReservationStop/Delete";

export const Get_Stop_Reservation_URL  = "ReservationStop/GetStopReservationStatus";
export const Stop_Reservations_URL     = "ReservationStop/StopReservations";